import { useState, useEffect } from 'react'
import { Sparkles } from 'lucide-react'
import { getChatStatus } from '@/services/chatApiService'
import ChatModal from './ChatModal'

// Robot Icon Component - Matching Figma Design
const RobotIcon = ({ className }: { className?: string }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Robot Head - Dark Green Circle */}
    <circle cx="12" cy="10" r="6" fill="#16a34a" />
    {/* White Eyes */}
    <circle cx="10" cy="9" r="1.5" fill="white" />
    <circle cx="14" cy="9" r="1.5" fill="white" />
    {/* Crescent Moon Shape Below Head - Darker Green */}
    <ellipse cx="12" cy="17" rx="4" ry="2.5" fill="#15803d" />
  </svg>
)

export default function ChatWidget() {
  const [enabled, setEnabled] = useState(false)
  const [open, setOpen] = useState(false)
  const [checked, setChecked] = useState(false)

  useEffect(() => {
    getChatStatus()
      .then((s) => {
        setEnabled(s.enabled)
        setChecked(true)
      })
      .catch(() => {
        setChecked(true)
      })
  }, [])

  if (!checked) return null
  // إظهار زر الشات دائماً حتى لو الـ API رجع enabled: false (المستخدم يشوف الزر؛ إذا الخدمة معطلة يظهر خطأ عند الإرسال)
  return (
    <>
      <div className="fixed bottom-4 right-4 sm:bottom-6 sm:right-6 z-[9999] pointer-events-none">
        {/* Orange/Yellow Sparkles - Top Left and Bottom Right */}
        <div className="absolute -top-1 left-0 sm:-top-2 sm:-left-2 w-2.5 h-2.5 sm:w-3 sm:h-3 text-orange-500 animate-pulse pointer-events-none" style={{ filter: 'drop-shadow(0 0 2px rgba(251, 146, 60, 0.8))' }}>
          <Sparkles className="w-full h-full" fill="currentColor" />
        </div>
        <div className="absolute -bottom-1 -right-1 sm:-bottom-2 sm:-right-2 w-2.5 h-2.5 sm:w-3 sm:h-3 text-orange-500 animate-pulse pointer-events-none" style={{ animationDelay: '0.5s', filter: 'drop-shadow(0 0 2px rgba(251, 146, 60, 0.8))' }}>
          <Sparkles className="w-full h-full" fill="currentColor" />
        </div>
        
        {/* Light Mint Green Pill Button - Figma Design */}
        <button
          type="button"
          onClick={() => setOpen(true)}
          className="relative flex items-center gap-1.5 sm:gap-2 px-3 py-2 sm:px-4 sm:py-2.5 rounded-full shadow-lg transition-all hover:scale-105 focus:ring-2 focus:ring-green-400 focus:ring-offset-2 dark:focus:ring-offset-gray-900 pointer-events-auto"
          style={{
            background: '#EAF7F2',
            border: '1px solid #16a34a',
            color: '#111827'
          }}
          aria-label="فتح المحادثة"
          data-tour="chat-button"
        >
          {/* GPT Text */}
          <span className="text-xs sm:text-sm font-bold">GPT</span>
          {/* Sakina Text */}
          <span className="text-xs sm:text-sm font-bold">سكينة</span>
          {/* Robot Icon */}
          <RobotIcon className="w-4 h-4 sm:w-5 sm:h-5 flex-shrink-0" />
        </button>
      </div>
      <ChatModal open={open} onClose={() => setOpen(false)} />
    </>
  )
}
